import classNames from 'classnames';
import { FC, ReactEventHandler, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { Tooltip } from '~shared/ui';

import styles from './siderButton.module.scss';

interface SiderButtonProps {
  title?: string;
  path?: string;
  icon?: ReactNode;
  collapsed?: boolean;
  onClick?: ReactEventHandler;
  badgeCount?: number;
}

export const SiderButton: FC<SiderButtonProps> = ({
  title,
  path = '/',
  icon,
  collapsed = false,
  onClick,
  badgeCount = 0,
}) => {
  const btnClass = (isActive: boolean) => {
    return classNames(
      styles.wrapper,
      collapsed ? styles.collapsed : '',
      isActive ? styles.active : ''
    );
  };

  const showBadge = badgeCount > 0;
  const badgeLabel = badgeCount > 99 ? '99+' : String(badgeCount);

  return (
    <Tooltip title={!collapsed ? title : null} placement="left" color="var(--stroke)">
      <NavLink onClick={onClick} className={({ isActive }) => btnClass(isActive)} to={path || '/'}>
        <div className={styles.icon}>
          <span
            style={{
              position: 'relative',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
            {showBadge && (
              <span
                style={{
                  position: 'absolute',
                  top: -4,
                  right: -6,
                  minWidth: 18,
                  height: 18,
                  padding: '0 5px',
                  borderRadius: 9,
                  background: 'var(--red, #ff4d4f)',
                  color: '#fff',
                  fontSize: 11,
                  lineHeight: '18px',
                  fontWeight: 600,
                  textAlign: 'center',
                  boxShadow: '0 0 0 2px var(--white, #fff)',
                }}
              >
                {badgeLabel}
              </span>
            )}
          </span>
        </div>
        <p className={`${styles.name} ${collapsed && styles.nameShow}`}>{title}</p>
      </NavLink>
    </Tooltip>
  );
};
